export function SingleChoiceClassificationIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect width='16' height='16' rx='8' fill='currentColor' />
      <circle cx='8' cy='8' r='3' fill='white' />
    </svg>
  )
}
